// STEP 3: Services calculation
import * as Yup from 'yup';

import { ICalculationDiscountItem } from './ICalculationDiscountItem';
import { IServiceListItem } from './IServiceListItem';

// Adriagateov price correction item
export const NEGATIVE_PRICE_SERVICE_ID = 1073;

export const ServicesValidationSchema = Yup.object().shape({
  serviceId: Yup.number().required('Required'),
  dateFrom: Yup.string(),
  dateTo: Yup.string(),
  unitOfMeasureId: Yup.number().required('Required'),
  sellingPricePerUnitOfMeasure: Yup.number()
    .required('Required')
    .when('serviceId', {
      is: NEGATIVE_PRICE_SERVICE_ID,
      otherwise: schema => schema.moreThan(0, 'Must be greater than 0'),
    }),
  amount: Yup.string(),
  isEditVisible: Yup.boolean(),
  isDeleteVisible: Yup.boolean(),
  numberOfGuests: Yup.number(),
  totalAmount: Yup.number(),
});

export type TServiceTableData = {
  id: string | null;
  rootId: number;
  serviceName: string;
  objectDefined?: boolean;
  isBasicService?: boolean;
  unitOfMeasureName: string;
  unitOfMeasureId: number;
  dateFrom: string;
  dateTo: string;
  sellingPricePerUnitOfMeasure: number;
  purchasePricePerUnitOfMeasure: number;
  serviceCurrencySymbol: string;
  serviceCurrencyISO: string;
  amount: number;
  totalSellingAmountPerUnitOfMeasure: number;
  isEditVisible?: boolean;
  isDeleteVisible?: boolean;
  unitOfMeasureRootId?: number;
  adults?: number;
  babies?: number;
  children?: number;
  teens?: number;
};

export type TCalculationTableState = {
  isServiceSideBarOpen: boolean;
  isDiscountSideBarOpen: boolean;
  isServiceEdit: boolean;
  isDiscountEdit: boolean;
  servicesTableData: TServiceTableData[];
  discountsTableData: TDiscountTableData[];
  rowIndex: number | null;
};

export type TServicesTableDataCalculation = {
  serviceId: number | string;
  unitOfMeasureId: number | string;
  dateFrom: string;
  dateTo: string;
  sellingPricePerUnitOfMeasure?: number | string;
  amount?: number | string;
  numberOfGuests: number;
  totalAmount?: number;
  reservationLanguageId?: number | null;
  adults?: number;
  babies?: number;
  children?: number;
  teens?: number;
};

export type TDataFromStepOne = {
  channelId: string;
  calculationStatus: string | number;
  unitId: string;
  dateFrom: string;
  dateTo: string;
  grownUps: number;
  teens: number;
  children: number;
  babies: number;
  serviceId: string | number;
  currencyId: string | number;
  languageId: string | number;
};

export type TApiData = {
  unitId: string;
  calculationServices: TServicesTableDataCalculation[];
  calculationDiscountServices: TDiscountTableDataCalculation[];
};

export type TCalculationServicesAndDiscounts = {
  totalReservationAmount: number;
  totalServicesAmount: number;
  totalDiscountServicesAmount: number;
  currencyISO: string;
  currencySymbol: string;
  services: IServiceListItem[];
  discountServices: IServiceListItem[];
};

// STEP 3: Discounts calculation
export const DiscountValidationSchema = Yup.object().shape({
  serviceId: Yup.number(),
  reservationDiscountType: Yup.string().required('Required'),
  amountPerDiscountType: Yup.string().required('Required'),
  applyDiscountPriceTo: Yup.string(),
});

export type TDiscountTableData = {
  id: string | null;
  rootId: number;
  objectDefined: boolean;
  discountName: string;
  reservationDiscountType: string;
  amountPerDiscountType: number;
  serviceCurrencyISO: string;
  currencyISO?: string;
  totalAmount: number;
  applyDiscountPriceTo?: boolean;
  dateFrom?: string;
  dateTo?: string;
};

export type TDiscountTableDataCalculation = {
  serviceId?: number;
  reservationDiscountType: string;
  amountPerDiscountType: string | number;
  applyDiscountPriceTo?: string | boolean;
  dateFrom?: string;
  dateTo?: string;
  numberOfGuests?: number;
  reservationLanguageId?: number;
};
